import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import config from 'utils/config';

export default class Date extends Component {

  /* Render */

  render() {
    const { format, value } = this.props;
    let momentObject;

    if (typeof value === 'string') {
      momentObject = moment(value);
    } else {
      momentObject = value;
    }

    const formattedDate = momentObject.format(format);

    return (
      <span className="date">
        {formattedDate}
      </span>
    );
  }
}

Date.defaultProps = {
  format: config.dateFormat,
};

Date.propTypes = {
  format: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};



// WEBPACK FOOTER //
// ./js/components/date/index.jsx